import { DebtNegativeStatus } from '@libs/renegkit/types';
import {
  getV1AppOffersByCreditorSlug,
  postV1AppOffersExpressOfferExperimental,
  ViewmodelInstallmentPaymentMethod,
  ViewmodelNegotiationTypeOption,
  postV1AppOffersTerms,
  postV1AppAgreementsByCreditorSlugClose,
  ViewmodelCloseAgreementRequest,
  getV1AppHelmetOffersByOfferIdResume,
  getV1AppHelmetOffersByOfferIdModalities,
  getV1AppHelmetOffersByOfferIdPaymentMethods,
  ViewmodelHelmetOfferResume,
  ViewmodelHelmetOfferModality,
  ViewmodelHelmetPaymentMethods,
} from '@acordocertobr/reneg-offers-hub';
import apiService from '../api/api.service';
import { currencyToLocale } from '@libs/utils/helpers/currencyToLocale';
// import { resolveMock } from '@libs/renegkit/_mocks/utils';
// import { itauPRAMock } from '@libs/renegkit/_mocks/checkout/itau';

export const getExpressOfferExperimental = (prioritaryCreditor: string) => {
  return postV1AppOffersExpressOfferExperimental({ client: apiService, body: { priorityCreditors: [prioritaryCreditor] } }).then((r) => r?.data);
};

export const getOffer = ({
  creditorSlug,
  systemSlug,
  offerId,
  paymentOptionId,
  paymentMethod,
  negotiationTypeOpt,
  abVariant,
  checkoutRedirectVariant,
}: {
  creditorSlug: string;
  systemSlug?: string;
  offerId?: string;
  paymentOptionId?: string; // caso a pessoa selecione ou caso quisermos forçar uma pré seleção de parcelamento (ideia do airtera)
  paymentMethod?: ViewmodelInstallmentPaymentMethod; // caso a pessoa selecione
  negotiationTypeOpt?: ViewmodelNegotiationTypeOption; // caso a pessoa selecione algum negotiation type diferente tipo o PRA
  abVariant?: string;
  checkoutRedirectVariant?: string;
}) => {
  // return resolveMock(itauPRAMock.data as any);
  const extraHeaders: Record<string, string> = {};
  if (abVariant) extraHeaders['x-ab-variant'] = abVariant;
  // TODO: descontinuar teste a/b via header, gambs temporária pra adaptar o teste de itau que ja havia subido
  if (checkoutRedirectVariant) extraHeaders['x-checkout-redirect-variant'] = checkoutRedirectVariant;

  return getV1AppOffersByCreditorSlug({
    client: apiService,
    path: { creditor_slug: creditorSlug },
    query: {
      system_slug: systemSlug,
      offer_id: offerId,
      payment_opt_id: paymentOptionId,
      payment_method: paymentMethod,
      negotiation_type_opt: negotiationTypeOpt,
    },
    ...(Object.keys(extraHeaders).length > 0 && { headers: extraHeaders }),
  }).then((d: any) => d.data!);
};

export const getOfferTerm = (debtId: number, paymentOptionId: number, hasChange?: boolean, installmentsNumber?: number) => {
  // TODO: fix type? ViewmodelOfferTermsRequest will need hasChange/installmentsNumber added after BFF update
  return postV1AppOffersTerms({ client: apiService, body: { debtId, paymentOptionId, hasChange, installmentsNumber } as any }).then(
    (d) => d.data! as unknown as string
  );
};

export const closeAgreement = (creditorSlug: string, payload: ViewmodelCloseAgreementRequest) => {
  return postV1AppAgreementsByCreditorSlugClose({ client: apiService, path: { creditor_slug: creditorSlug }, body: payload }).then((d) => d.data!);
};

export const getIsDebtNegative = (status: DebtNegativeStatus) => {
  const isNegativeStatus = status === 'BOTH' || status === 'SCPC' || status === 'PARTNER';
  return isNegativeStatus;
};

export const getIsSCPCNegative = (status: DebtNegativeStatus) => {
  return status === 'BOTH' || status === 'SCPC';
};

export const getHelmetOfferResume = (offerId: string | number): Promise<ViewmodelHelmetOfferResume | undefined> =>
  getV1AppHelmetOffersByOfferIdResume({ client: apiService, path: { offer_id: String(offerId) } }).then((r: any) => r?.data);

export const getHelmetOfferModalities = (offerId: string | number): Promise<ViewmodelHelmetOfferModality[]> =>
  getV1AppHelmetOffersByOfferIdModalities({ client: apiService, path: { offer_id: String(offerId) } }).then(
    (r: any) => (r?.data ?? []) as ViewmodelHelmetOfferModality[]
  );

export const getHelmetOfferPaymentMethods = (offerId: string | number, installmentId = ''): Promise<ViewmodelHelmetPaymentMethods | undefined> =>
  getV1AppHelmetOffersByOfferIdPaymentMethods({
    client: apiService,
    path: { offer_id: String(offerId) },
    query: { installment_id: installmentId },
  }).then((r: any) => r?.data);

export const getDiscountAmount = (currentValue: number, agreementValue: number) => {
  if (agreementValue >= currentValue) return currencyToLocale(0);

  const diff = currentValue - agreementValue;
  return currencyToLocale(diff);
};
